import {
  Accordion,
  AccordionItem,
  Button,
  Label,
  Modal,
  Table,
  TableContent,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "@forge/common";
import { useNavigate } from "react-router";
import { localeKeyMap } from "../../localization/keys";
import SettingMetaDataDTO from "../../models/SettingDTO";
import "./MoreInfo.scss";
import { useTranslation } from "@scuf/localization"

interface moreInfoProps {
  closeHandler(): void;
  tenantId: string;
  data: Array<SettingMetaDataDTO>;
}

export const MoreInfo: any = (props: moreInfoProps) => {
  const navigate = useNavigate();
  const [t] = useTranslation();

  const cancelButtonFooterLeft = (
    <Accordion
      id="more-info-settings"
      className={`more-info-container p-20 color-bg-details`}
    >
      {props.data.map((prod) => {
        return (
          <AccordionItem
            id={prod.productId}
            title={prod.productName + " " + t(localeKeyMap.settingsInformation)}
            onToggle={function noRefCheck() {}}
          >
            <div>
              <Table className="table-container-more-info">
                <TableHead>
                  <TableRow>
                    <TableHeaderCell id={prod.productId + "key"}>
                      <Label>{t(localeKeyMap.setting)}</Label>
                    </TableHeaderCell>
                    <TableHeaderCell id={prod.productId + "value"}>
                      <Label>{t(localeKeyMap.value)}</Label>
                    </TableHeaderCell>
                  </TableRow>
                </TableHead>

                {/* prod.settings.map((set) => { 
                //return (
                  
                  // <Grid cols={1}>
                   
                      
                    
                  //   {<Cell>
                  //     <Tooltip
                  //       position="bottom-right"
                  //       content={set.displayName}
                  //       className="tool-tip-content"
                  //     >
                  //       <Label>{set.displayName}</Label>
                  //     </Tooltip>
                  //   </Cell>
                  //   <Cell>
                  //     <Tooltip
                  //       content={set.value}
                  //       position="bottom-right"
                  //       className="tool-tip-content"
                  //     >
                  //       <p className="body-1">{set.value}</p>
                  //     </Tooltip>
                  //   </Cell> }
                  // </Grid>
              //  );   
                        
             });
             */}
                <TableContent
                  data={prod.settings.map((set) => {
                    return {
                      id: "set.displayName",
                      cell: [
                        { content: set.displayName },
                        { content: set.value },
                      ],
                    };
                  })}
                ></TableContent>
              </Table>
            </div>
          </AccordionItem>
        );
      })}
    </Accordion>
  );

  return (
    <Modal
      className="mx-auto w-[90vw] max-w-4xl h-[90%] modal-more-info"
      children={cancelButtonFooterLeft}
      onBackdropClick={props.closeHandler}
      onModalClose={props.closeHandler}
      fullContent={false}
      backdrop={true}
      footerRight={
        <div className="footer-container-more-info">
          <Button
            variant="secondary"
            onClick={() => {
              navigate(`/tenant/EditSettings/${props.tenantId}`);
            }}
            className="button-actions"
          >
            {t(localeKeyMap.edit)}
          </Button>
          <Button
            variant="primary"
            onClick={props.closeHandler}
            className="button-actions"
          >
            {t(localeKeyMap.close)}
          </Button>
        </div>
      }
      title={t(localeKeyMap.moreInformation)}
    />
  );
};